/* eslint-disable react/no-danger */
import React, { Fragment } from 'react';
import Image from 'next/future/image';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import sanitizeHtml from 'sanitize-html';
import has from 'lodash/has';
import isEmpty from 'lodash/isEmpty';
import Link from 'next/link';
import { BlogTileStyles } from './BlogListComponentStyles';

const TERM = 'wp:term';
const MEDIA = 'wp:featuredmedia';

const BlogTile = ({ data, buttonText = 'Read Article' }) => {
  const { title, slug, _embedded, date, excerpt } = data;

  const hasTerm = has(_embedded, TERM) && !isEmpty(_embedded[TERM]);
  const hasMedia = has(_embedded, MEDIA) && !isEmpty(_embedded[MEDIA]);

  const categories = hasTerm ? _embedded[TERM][0] : [];
  const thumbnailPlaceholder = '/static/images/blog/img-placeholder.png';
  const thumbnailImage =
    (hasMedia
      ? _embedded[MEDIA][0]?.media_details?.sizes['blog-thumbnail-large']?.source_url ||
      _embedded[MEDIA][0]?.source_url
      : thumbnailPlaceholder) || thumbnailPlaceholder;

  const datePublished = new Date(date);
  const formattedPublished = dayjs(datePublished).format('MMMM D, YYYY');

  const sanitizeSettings = {
    allowedTags: [],
  };

  return (
    <BlogTileStyles className="post" data-cy="blog-tile">
      <div className="post__thumbnail-wrap">
        <Link href="/blog/[slug]" as={`/blog/${slug}`}>
          <a title={title.rendered}>
            <img src={thumbnailImage} alt={slug} width={1200}
                             height={600}
                             layout="raw" />
          </a>
        </Link>
      </div>
      <div className="post__preview">
        <h2 className="post__title">
          <Link href="/blog/[slug]" as={`/blog/${slug}`}>
            <a
              title={title.rendered}
              dangerouslySetInnerHTML={{
                __html: sanitizeHtml(title.rendered, sanitizeSettings),
              }}
            />
          </Link>
        </h2>
        <div className="post-category">
          {categories.map((c, i) => {
            const isLastItem = i + 1 === categories.length;
            return (
              <Fragment key={c.id}>
                <Link href="/blog/topics/[category]" as={`/blog/topics/${c.slug}`}>
                  <a rel="tag">{c.name}</a>
                </Link>
                {!isLastItem ? ', ' : null}
              </Fragment>
            );
          })}
        </div>
        <p
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(excerpt.rendered, sanitizeSettings).replace(
              ' View Article',
              ''
            ),
          }}
        ></p>
      </div>
      <div className="post__footer">
        <Link href="/blog/[slug]" as={`/blog/${slug}`}>
          <a className="btn btn-primary" data-cy="blog-title-cta">
            {buttonText}
          </a>
        </Link>
        <div className="post__info">
          <div className="post__date">
            <span className="post__date__icon" />
            <span className="post__date__text">{formattedPublished}</span>
          </div>
        </div>
      </div>
    </BlogTileStyles>
  );
};

BlogTile.propTypes = {
  data: PropTypes.object.isRequired,
  buttonText: PropTypes.string,
};

export default BlogTile;
